export default {
  resmy_orders: "My Orders",
  resorders_subtitle: "View and manage all your restaurant orders",

  resshow_normal_orders: "Show Normal Orders",
  resshow_recurring_orders: "Show Recurring Orders",

  ressearch_order: "Search Order ID",
  resall_status: "All Status",
  resplaced: "Placed",
  resconfirmed: "Confirmed",
  resout_for_delivery: "Out For Delivery",
  resdelivered: "Delivered",
  resrejected: "Rejected",

  resorders_found: "Orders Found",

  resdate: "Date",
  resproducts: "Products",
  restotal: "Total",
  resdaily: "Daily",
  resaction: "Action",

  resno_orders: "No orders found",

  resmake_daily: "Make Daily",
  respause: "Pause",
  resview: "View",
  resmodify: "Modify",
  rescancel: "Cancel",

  resrecurring_setup: "Setup Recurring Order",
  resfrequency: "Frequency",
  resweekly: "Weekly",
  resselect_days: "Select Days",
  resstart_date: "Start Date",
  resend_date: "End Date",
  resactivate: "Activate",

  
  resaccepted: "Accepted",
  respacked: "Packed",
  resmore: "more",
  resconfirm_cancel_order: "Are you sure you want to cancel this order?",
  rescancel_success: "Order cancelled successfully",
  respause_confirm: "Pause this recurring order?",
  respause_success: "Recurring order paused",
  resrecurring_activated: "Recurring activated 🔥",
  ressomething_wrong: "Something went wrong",
  resrepeat_daily_from: "This order will repeat daily starting",
  resrepeat_weekly_on: "This order will repeat on",
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
  saturday: "Sat",
  sunday: "Sun",
  ressupplier_delivery: "Supplier Delivery",

ressingle_delivery: "Single Delivery",
ressplit_deliveries: "Split Deliveries",

resview_btn: "View ▼",
reshide_btn: "Hide ▲",

resmonday: "Monday",
restuesday: "Tuesday",
reswednesday: "Wednesday",
resthursday: "Thursday",
resfriday: "Friday",
ressaturday: "Saturday",
ressunday: "Sunday",
resview_expand: "View ▼",
reshide_expand: "Hide ▲",
last7days: "Last 7 Days",
last30days: "Last 30 Days",
last3months: "Last 3 Months",
all: "All",

ressearch_order_supplier:
  "Search by Order ID, Reference ID or Supplier...",

};